export default __webpack_public_path__ + "static/media/AutoJoinDisable.96afa4d8.svg";